import { ACCOUNTS } from "../../../model/accounting/Chart.js";
import { DebitOrCredit } from "../../../model/accounting/DebitOrCredit.js";
import { Account } from "../../../model/accounting/account/Account.js";
import { creditEffect, debitEffect } from "../../../model/accounting/account/accountEffect.js";
import { SelectOption } from "../../../../packages/ui/form/select/SelectOption.js";

/**
 * Constructs select options for debit account selector.
 */
const createDebitOptions = () => {
  const options = ACCOUNTS.map((account) => createAccountOption(account, "debit"));
  options.unshift(emptyOption);
  return options;
};

/**
 * Constructs select options for credit account selector.
 */
const createCreditOptions = () => {
  const options = ACCOUNTS.map((account) => createAccountOption(account, "credit"));
  options.unshift(emptyOption);
  return options;
};

const createAccountOption = (account: Account, forType: DebitOrCredit): SelectOption => {
  const effect = forType === "credit" ? creditEffect(account.type) : debitEffect(account.type);
  return {
    value: account.id,
    label: `${account.code} (${account.name}) ${effect < 0 ? "-" : "+"}`
  };
};

const emptyOption: SelectOption = { value: "", label: "Vali konto" };

export const debitAccountOptions = createDebitOptions();
export const creditAccountOptions = createCreditOptions();
